import React from 'react';
import { Loader } from '@eika/loader';
const OverlayLoader = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: "overlay-loader"
  }, /*#__PURE__*/React.createElement(Loader, {
    className: "loader"
  }));
};
export default OverlayLoader;